import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=81b4102a&scoped=true"
import script from "./TitleBar.vue?vue&type=script&lang=js"
export * from "./TitleBar.vue?vue&type=script&lang=js"
import style0 from "./TitleBar.vue?vue&type=style&index=0&id=81b4102a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b4102a",
  null
  
)

export default component.exports